import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'headquarter-customers';

const getCustomerById = async (id) => {
  const method = 'GET';
  const url = `${USE_CASE_URL}/${id}`;

  const json = await request({ method, url });
  return json;
};

export default getCustomerById;
